import { AfterViewInit, Component, Inject } from '@angular/core';
import { TimerService } from './core/services/timer.service';
import { APP_ENVIRONMENT, AppEnvironment } from "src/app/app.environment";
import { RouteHistoryService } from './core/services/route-history.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [RouteHistoryService],
    standalone: false
})
export class AppComponent{
  title = 'Broadspire Reports';
  baseUrl = '';

  constructor(
    @Inject(APP_ENVIRONMENT) appEnvironment: AppEnvironment,
    private routeHistoryService: RouteHistoryService) {
     this.baseUrl = appEnvironment.baseUrl;
     this.routeHistoryService.listenToRouter();
  }
}
